import { SET_CURRENT_FOOD_COURT } from "../actions";

export default function currentFoodCourt(state = null, action) {
  switch (action.type) {
    case SET_CURRENT_FOOD_COURT:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/currentFoodCourt.js